import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import { setDialedNumberInc } from "../../Redux/Actions/actions";
import voice from "../../Assets/images/other/voice.png";
import { toast } from "react-toastify";
import { FunnelSimple } from "@phosphor-icons/react";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import axios from "axios";
import {
  BaseUrl,
  VoiceDomainName,
  VoiceDomainNamePure,
} from "../../Container/BaseUrl/BaseUrl";
import {
  IconButton,
  Pagination,
  Skeleton,
  Stack,
  Box,
  Typography,
  Drawer,
  ButtonGroup,
} from "@mui/material";
import { RiErrorWarningLine } from "react-icons/ri";
import moment from "moment";
import { Swap } from "@phosphor-icons/react";
import { toaststyle } from "../../Utils/toaststyle";
import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
} from "../../CustomComponent/TableCompoent";
import { Hourglass } from "react-loader-spinner";
import { TiWarningOutline } from "react-icons/ti";

const mapStateToProps = (state) => {
  return { skillset: state.data.skillset };
};

const AgentContact = (props) => {
  const agent = JSON.parse(localStorage.getItem("tokenAgent"));

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return !todate || !fromdate || new Date(todate) >= new Date(fromdate);
  };
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);
  const [pagination2, setPagination2] = useState(0);
  const [page2, setPage2] = useState(1);
  const [pagination3, setPagination3] = useState(0);
  const [page3, setPage3] = useState(1);
  const [pagination4, setPagination4] = useState(0);
  const [page4, setPage4] = useState(1);
  const [showSupervisorfilter, setShowSupervisorfilter] = useState(false);

  const [buttontype1, setbuttontype1] = useState("contained");
  const [buttontype2, setbuttontype2] = useState("outlined");
  const [buttontype3, setbuttontype3] = useState("outlined");
  const [buttontype4, setButtontype4] = useState("outlined");
  const [serviceReportList, setServiceReportList] = useState([]);
  const [salesReport, setSalesReport] = useState([]);
  const [smsReport, setSmsReport] = useState([]);
  const [loadingAgentService, setLoadingAgentService] = useState(false);
  const [loadingAgentSales, setLoadingAgentSales] = useState(false);
  const [loadingAgentreport, setLoadingAgentreport] = useState(false);
  const [loadingSmsCount, setLoadingSmsCount] = useState(false);
  const [tableListType, settableListType] = useState("table1");
  const [agentCount, setagentCount] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [brand, setBrand] = useState("");
  const [tableType, settableType] = useState("Service");

  const ServiceReport = async (value) => {
    setLoadingAgentService(true);
    await axios
      .post(
        BaseUrl + "/contact/listAgentservicereport",
        {
          from_date: tableType == "Service" ? fromdate : defaultValue,
          to_date: tableType == "Service" ? todate : defaultValue,
          offset: value == null ? 0 : value == 1 ? 0 : (value - 1) * 10,
          limit: 10,
          agent_id: agent.agent_id,
          brand: brand,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        console.log("SERVEICEAPI", res);

        if (res.data.status) {
          setServiceReportList(res.data.data);
          setPagination(res.data.count);
          setTimeout(() => {
            setLoadingAgentService(false);
          }, 1000);
        } else {
          setServiceReportList([]);
          setTimeout(() => {
            setLoadingAgentService(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("AgentContact", error);
        setTimeout(() => {
          setLoadingAgentSales(false);
        }, 1000);
      });
  };
  const SalesReport = async (value) => {
    setLoadingAgentSales(true);
    await axios
      .post(
        BaseUrl + "/contact/listAgentreport",
        {
          from_date: tableType == "Sales" ? fromdate : defaultValue,
          to_date: tableType == "Sales" ? todate : defaultValue,
          offset: value == null ? 0 : value == 1 ? 0 : (value - 1) * 10,
          limit: 10,
          agent_id: agent.agent_id,
          brand: brand,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        console.log("salesssApi", res);
        if (res.data.status) {
          setSalesReport(res.data.data);
          setPagination2(res.data.count);
          setTimeout(() => {
            setLoadingAgentSales(false);
          }, 1000);
        } else {
          setSalesReport([]);
          setTimeout(() => {
            setLoadingAgentSales(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("AgentContact", error);
        setTimeout(() => {
          setLoadingAgentSales(false);
        }, 1000);
      });
  };
  const smsCountReportAgent = () => {
    setLoadingSmsCount(true);
    let body = {
      agent_id: agent.agent_id,
      offset: page == 1 ? 0 : (page - 1) * 10,
      limit: 10,
    };
    axios
      .post(BaseUrl + "/contact/smssendcount", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.success == true) {
          setSmsReport(res.data.Data);
          setPagination4(res.data.count);
          setTimeout(() => {
            setLoadingSmsCount(false);
          }, 1000);
        } else {
          setPagination4(0);
          setTimeout(() => {
            setLoadingSmsCount(false);
          }, 1000);
        }
      });
  };
  const agentCallcount = async () => {
    setLoadingAgentreport(true);
    let body = {
      offset: page3 == 1 ? 0 : (page3 - 1) * 10,
      limit: 10,
      agent_id: agent.agent_id,
    };
    await axios
      .post(BaseUrl + "/contact/callcontactcount", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.success == true) {
          setagentCount(res.data.Data);
          setPagination3(res.data.count);
          setTimeout(() => {
            setLoadingAgentreport(false);
          }, 1000);
        } else {
          setagentCount([]);
          setPagination3(0);
          setTimeout(() => {
            setLoadingAgentreport(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const makeCall = (calledNo, type, id, reg_no) => {
    let number = `${calledNo}`;
    if (
      localStorage.getItem("AgentStatus") == "Ready" ||
      localStorage.getItem("AgentStatus") == "Not Ready"
    ) {
      localStorage.setItem("callActivate", "true");
      localStorage.setItem("CallMadeFromDcc", "true");
      let agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
      let avcurlid = localStorage.getItem("AvcUrl");
      props.setDialedNumberInc(number);
      localStorage.setItem("callDirectionType", "Outbound");
      localStorage.setItem("ClickeToCallPhoneNum", number);
      localStorage.setItem("dailedNumber", number);
      localStorage.setItem("ClickToCall", "true");
      localStorage.setItem("clickToCallCallerID", id);
      axios
        .post(
          avcurlid +
            `/voice/terminal/${agentLoginTerminalId}/createContact/sip:${agentLoginTerminalId}@${VoiceDomainName}/sip:${number}@${VoiceDomainName}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then(async (res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("type", type);
            localStorage.setItem("ContactVoiceId", id);
            localStorage.setItem("Contactreg_no", reg_no);
            let body = {
              phonenumber: calledNo,
              skillset: "customer service",
              channel: "voice",
              type: type,
              reg_no: reg_no,
              contact_id: id,
              direction: "OUTBOUND",
            };
            await axios
              .post(BaseUrl + "/ticket/crmscreenpop", body, {
                headers: {
                  Authorization:
                    "Bearer " + localStorage.getItem("access_token"),
                  "Content-Type": "application/json",
                  tenantId: localStorage.getItem("TenantId"),
                },
              })
              .then((res) => {
                window.open(res.data.data);
                toast.success("screen pop url generated", toaststyle);
              })
              .catch((error) => {
                toast.warning("screen pop url not generated", toaststyle);
              });
            // localStorage.setItem("ClickToCall", "true");
          } else {
            toast.warn(res.data.status, toaststyle);
          }
        })
        .catch((err) => {
          if (err.code == "ERR_BAD_REQUEST") {
            toast.error("Please change status to Ready", toaststyle);
          }
        });
    } else {
      toast.error("Please change status to Ready", toaststyle);
    }
  };
  const takeSurvey = async (item, type) => {
    let body = {
      phonenumber: item.Mobile ? item.Mobile : item.MOBILE,
      skillset: "customer service",
      channel: "voice",
      type: type,
      reg_no: item.Registration_No ? item.Registration_No : item.REG_NO,
      contact_id: item.id,
      direction: "OUTBOUND",
    };
    await axios
      .post(BaseUrl + "/ticket/crmscreenpop", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        window.open(res.data.data);
        toast.success("screen pop url generated", toaststyle);
      })
      .catch((error) => {
        toast.warning("screen pop url not generated", toaststyle);
      });
  };

  const fetchData = () => {
    if (tableType === "Service") {
      ServiceReport();
    } else if (tableType === "Sales") {
      SalesReport();
    }
    setShowSupervisorfilter(false);
    setPage2(1);
  };

  const handleChange = (event, value) => {
    setPage(value);
    ServiceReport(value);
  };
  const handleChange2 = (event, value) => {
    setPage2(value);
    SalesReport(value);
  };
  const handleChange3 = (event, value) => {
    setPage3(value);
    agentCallcount();
  };
  const handleChange4 = (event, value) => {
    setPage4(value);
    smsCountReportAgent();
  };

  useEffect(() => {
    handleChange;
  }, []);

  useEffect(() => {
    if (tableType === "Service") {
      ServiceReport();
      setShowSupervisorfilter(false);
    } else if (tableType === "Sales") {
      SalesReport();
      setShowSupervisorfilter(false);
    }
  }, []);

  useEffect(() => {
    setPage2(1);
  }, [tableType]);

  return (
    // Agent contact start here
    <StyledPaper>
      {/* card start here */}
      <div className="card Report-card w-100 border-0">
        {/* card-header  */}
        <div
          className="card-header border-0 d-flex align-items-center justify-content-between px-2"
          sx={{ fontWeight: 600, color: "#1473e6" }}
        >
          <div
            className="fw-bold fs-16"
            style={{
              textShadow: "1px 0px 0px #c2c2c27d",
              color: "#0b3363",
            }}
          >
            <Stack className="d-flex flex-row gap-1">
              <Button
                disableElevation
                size="small"
                id="primary-btn"
                variant={buttontype1}
                onClick={() => {
                  setbuttontype1("contained");
                  setbuttontype2("outlined");
                  setbuttontype3("outlined");
                  setButtontype4("outlined");
                  settableType("Service");

                  setPage(1);
                  if (tableType != "Service") {
                    setFromdate(defaultValue);
                    setTodate(defaultValue);
                  }
                  ServiceReport();
                  setPagination(0);
                  settableListType("table1");
                  setShowSupervisorfilter(false);
                  localStorage.setItem("surveyType", "Service");
                }}
                sx={{
                  textTransform: "capitalize",
                }}
              >
                Service
              </Button>
              <Button
                disableElevation
                size="small"
                id="primary-btn"
                variant={buttontype2}
                onClick={() => {
                  setbuttontype1("outlined");
                  setbuttontype2("contained");
                  setbuttontype3("outlined");
                  setButtontype4("outlined");
                  settableType("Sales");

                  if (tableType != "Sales") {
                    setFromdate(defaultValue);
                    setTodate(defaultValue);
                  }
                  SalesReport();
                  setPage2(1);
                  setPagination2(0);
                  settableListType("table2");
                  setShowSupervisorfilter(false);
                  localStorage.setItem("surveyType", "Sales");
                }}
                sx={{
                  textTransform: "capitalize",
                }}
              >
                Sales
              </Button>

              <Button
                disableElevation
                size="small"
                id="agent-primary-btn"
                variant={buttontype3}
                onClick={() => {
                  setbuttontype1("outlined");
                  setbuttontype2("outlined");
                  setbuttontype3("contained");
                  setButtontype4("outlined");
                  setShowSupervisorfilter(false);
                  agentCallcount();
                  settableListType("table3");

                  localStorage.setItem("surveyType", "AgentReport");
                }}
                sx={{
                  textTransform: "capitalize",
                }}
              >
                Agent Report
              </Button>
              {/* <Button
                disableElevation
                size="small"
                id="agent-primary-btn"
                variant={buttontype4}
                onClick={() => {
                  setbuttontype1("outlined");
                  setbuttontype2("outlined");
                  setbuttontype3("outlined");
                  setButtontype4("contained");
                  settableListType("table4");
                  setShowSupervisorfilter(false)
                  localStorage.setItem("surveyType", "smsCount");
                  smsCountReportAgent();
                }}
                sx={{
                  textTransform: "capitalize",
                }}
              >
                SMS count
              </Button> */}
            </Stack>
          </div>
          {localStorage.getItem("surveyType") == "AgentReport" ||
          localStorage.getItem("surveyType") == "smsCount" ? (
            <></>
          ) : (
            <div>
              <ButtonGroup
                variant="contained"
                aria-label="button group"
                disableElevation
                size="small"
                sx={{
                  textTransform: "capitalize",
                }}
              >
                {/* Filter btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setShowSupervisorfilter(true);
                  }}
                >
                  <FunnelSimple className="me-2" />
                  Filter
                </Button>
              </ButtonGroup>
            </div>
          )}
        </div>
        {(() => {
          switch (tableListType) {
            case "table1":
              return (
                <>
                  {/* card-body */}
                  <div
                    className="card-body p-1 vh-71 box-inset"
                    sx={{
                      justifyContent: "center",
                      display: "flex",
                      height: "calc(100% - 40px)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10",
                    }}
                  >
                    <Box>
                      <StyledTableContainer sx={{ height: "26rem !important" }}>
                        <StyledTable
                          stickyHeader
                          aria-label="sticky table"
                          size="small"
                        >
                          <>
                            <StyledTableHead>
                              <StyledTableRow>
                                {[
                                  "Action",
                                  "Brand",
                                  "Customer Name",
                                  "Customer Number",
                                  "Registration No",
                                  "Model Description",
                                  "Chassis No",
                                  "Job Card",
                                  "Invoice Date",
                                  "Location",
                                  "Service Advisor",
                                  "External Color",
                                  "Nature Of Work",
                                  "Job Type",
                                  "Call Status",
                                  "Date",
                                  "Timestamp",
                                  // "Action",
                                ].map((headers) => (
                                  <StyledTableCell
                                    style={{ minWidth: "150px" }}
                                  >
                                    {headers}
                                  </StyledTableCell>
                                ))}
                              </StyledTableRow>
                            </StyledTableHead>
                            {loadingAgentService ? (
                              <Stack
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                }}
                              >
                                <Hourglass
                                  visible={true}
                                  height="30"
                                  width="30"
                                  ariaLabel="hourglass-loading"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                  colors={["#2268a0", "#72a1ed"]}
                                />
                              </Stack>
                            ) : serviceReportList.length > 0 ? (
                              serviceReportList.map((rowData, rowIndex) => {
                                return (
                                  <StyledTableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={rowIndex.id}
                                  >
                                    <StyledTableCell2>
                                      <img
                                        className="icons-size"
                                        src={voice}
                                        alt="webchat"
                                        onClick={() => {
                                          makeCall(
                                            rowData.MOBILE,
                                            "service",
                                            rowData.id,
                                            rowData.REG_NO
                                          );
                                        }}
                                      />
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Brand}
                                    </StyledTableCell2>

                                    <StyledTableCell2>
                                      {rowData.CUST_NAME}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.MOBILE}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.REG_NO}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Model_Description}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.CHASSIS_NO}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Job_Card}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Invoice_Date}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Location}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.ADVISOR}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.External_Color}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.nature_of_work
                                        ? rowData.nature_of_work
                                        : ""}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.job_type ? rowData.job_type : ""}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.callstatus}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {moment(rowData.createdAt).format("L")}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {moment(rowData.createdAt).format(
                                        "hh:mm A"
                                      )}
                                    </StyledTableCell2>
                                    {/* <StyledTableCell2>
                                      <IconButton
                                        onClick={() => {
                                          takeSurvey(rowData, "service");
                                        }}
                                      >
                                        <Swap
                                          size={22}
                                          weight="bold"
                                          style={{ zIndex: 0 }}
                                        />
                                      </IconButton>
                                    </StyledTableCell2> */}
                                  </StyledTableRow>
                                );
                              })
                            ) : (
                              // Data unavailable start
                              <Stack
                                sx={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "calc(100vh - 14rem)",
                                }}
                                justifyContent="center"
                                alignContent="center"
                              >
                                <Stack
                                  className="text-muted"
                                  direction="column"
                                  justifyContent="center"
                                  alignContent="center"
                                >
                                  <span className="mx-auto">
                                    <img
                                      src={Nodata}
                                      alt="pic"
                                      style={{
                                        width: "11rem",
                                        userSelect: "none",
                                      }}
                                    />
                                  </span>
                                  <span className="mx-auto">
                                    <h6
                                      className="text-muted mt-3"
                                      style={{ fontSize: "13px" }}
                                    >
                                      Data unavailable
                                    </h6>
                                  </span>
                                </Stack>
                              </Stack>
                              // Data unavailable end
                            )}
                          </>
                        </StyledTable>
                      </StyledTableContainer>
                    </Box>
                  </div>
                  {/* card-footer */}
                  <div className="card-footer border-0">
                    <Box>
                      <Stack
                        sx={{ width: "100%", height: "100%" }}
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        {/* Pagination content  */}
                        <Typography variant="caption" sx={{ fontSize: "12px" }}>
                          Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                          {Math.min(page * 10, pagination)} of {pagination}{" "}
                          entries
                        </Typography>
                        {/* Pagination  */}
                        <Pagination
                          count={Math.ceil(pagination / 10)}
                          page={page}
                          shape="rounded"
                          color="primary"
                          size="small"
                          style={{ float: "right" }}
                          onChange={handleChange}
                        />
                      </Stack>
                    </Box>
                  </div>
                  {/* card-footer  end*/}
                </>
              );
            case "table2":
              return (
                <>
                  {/* card-body */}
                  <div
                    className="card-body p-1 vh-71 box-inset"
                    sx={{
                      justifyContent: "center",
                      display: "flex",
                      height: "calc(100% - 40px)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10",
                    }}
                  >
                    <Box>
                      <StyledTableContainer sx={{ height: "26rem !important" }}>
                        <StyledTable
                          stickyHeader
                          aria-label="sticky table"
                          size="small"
                        >
                          <>
                            <StyledTableHead>
                              <StyledTableRow>
                                {[
                                  "Action",
                                  "Delivary Date",
                                  "Call Status",
                                  "Brand",
                                  "Customer Name",
                                  "Customer Number",
                                  "Customer Email",
                                  "Address",
                                  "Model Description",
                                  "Chassis No",
                                  "Year",
                                  "Month",
                                  "Invoice No",
                                  "Invoice Date",
                                  "Location",
                                  "Salesman",
                                  "CustomerCategory",
                                  "Invoice Branch",
                                  "Date",
                                  "Timestamp",
                                  // "Action",
                                ].map((headers) => (
                                  <StyledTableCell
                                    style={{ minWidth: "150px" }}
                                  >
                                    {headers}
                                  </StyledTableCell>
                                ))}
                              </StyledTableRow>
                            </StyledTableHead>
                            {loadingAgentService ? (
                              <Stack
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                }}
                              >
                                <Hourglass
                                  visible={true}
                                  height="30"
                                  width="30"
                                  ariaLabel="hourglass-loading"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                  colors={["#2268a0", "#72a1ed"]}
                                />
                              </Stack>
                            ) : salesReport.length > 0 ? (
                              salesReport.map((rowData, rowIndex) => {
                                return (
                                  <StyledTableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={rowIndex.id}
                                  >
                                    <StyledTableCell2>
                                      <img
                                        className="icons-size"
                                        src={voice}
                                        alt="webchat"
                                        onClick={() => {
                                          makeCall(
                                            rowData.Mobile,
                                            "sales",
                                            rowData.id,
                                            rowData.Registration_No
                                          );
                                        }}
                                      />
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Delivery_Date}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.callstatus}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Brand}
                                    </StyledTableCell2>

                                    <StyledTableCell2>
                                      {rowData.Customer_Name}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Mobile}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Email}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Address2}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Model_Description}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Chassis_No}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Year}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.month ? rowData.month : ""}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Invoice_No}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Inv_Date}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Location}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Salesman}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Customer_Category}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Inv_Brch}
                                    </StyledTableCell2>

                                    <StyledTableCell2>
                                      {moment(rowData.createdAt).format("L")}
                                    </StyledTableCell2>

                                    <StyledTableCell2>
                                      {moment(rowData.createdAt).format(
                                        "hh:mm A"
                                      )}
                                    </StyledTableCell2>
                                    {/* <StyledTableCell2>
                                      <IconButton
                                        onClick={() => {
                                          takeSurvey(rowData, "sales");
                                        }}
                                      >
                                        <Swap size={22} weight="bold" />
                                      </IconButton>
                                    </StyledTableCell2> */}
                                  </StyledTableRow>
                                );
                              })
                            ) : (
                              // Data unavailable start
                              <Stack
                                sx={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "calc(100vh - 14rem)",
                                }}
                                justifyContent="center"
                                alignContent="center"
                              >
                                <Stack
                                  className="text-muted"
                                  direction="column"
                                  justifyContent="center"
                                  alignContent="center"
                                >
                                  <span className="mx-auto">
                                    <img
                                      src={Nodata}
                                      alt="pic"
                                      style={{
                                        width: "11rem",
                                        userSelect: "none",
                                      }}
                                    />
                                  </span>
                                  <span className="mx-auto">
                                    <h6
                                      className="text-muted mt-3"
                                      style={{ fontSize: "13px" }}
                                    >
                                      Data unavailable
                                    </h6>
                                  </span>
                                </Stack>
                              </Stack>
                              // Data unavailable end
                            )}
                          </>
                        </StyledTable>
                      </StyledTableContainer>
                    </Box>
                  </div>
                  {/* card-footer */}
                  <div className="card-footer border-0">
                    <Box>
                      <Stack
                        sx={{ width: "100%", height: "100%" }}
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        {/* Pagination content  */}
                        <Typography variant="caption" sx={{ fontSize: "12px" }}>
                          Showing {Math.min((page2 - 1) * 10 + 1, pagination2)}{" "}
                          to {Math.min(page2 * 10, pagination2)} of{" "}
                          {pagination2} entries
                        </Typography>
                        {/* Pagination  */}
                        <Pagination
                          count={Math.ceil(pagination2 / 10)}
                          page={page2}
                          shape="rounded"
                          color="primary"
                          size="small"
                          style={{ float: "right" }}
                          onChange={handleChange2}
                        />
                      </Stack>
                    </Box>
                  </div>
                  {/* card-footer  end*/}
                </>
              );
            case "table3":
              return (
                <>
                  {/* card-body */}
                  <div
                    className="card-body p-1 vh-71 box-inset"
                    sx={{
                      justifyContent: "center",
                      display: "flex",
                      height: "calc(100% - 40px)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10",
                    }}
                  >
                    <Box>
                      <StyledTableContainer sx={{ height: "26rem !important" }}>
                        <StyledTable
                          stickyHeader
                          aria-label="sticky table"
                          size="small"
                        >
                          <>
                            <StyledTableHead>
                              <StyledTableRow>
                                {[
                                  "Total Assign Call",
                                  "Total Pending Call",
                                  "Total Complete Call",
                                ].map((headers) => (
                                  <StyledTableCell
                                    style={{ minWidth: "150px" }}
                                  >
                                    {headers}
                                  </StyledTableCell>
                                ))}
                              </StyledTableRow>
                            </StyledTableHead>
                            {loadingAgentService ? (
                              <Stack
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                }}
                              >
                                <Hourglass
                                  visible={true}
                                  height="30"
                                  width="30"
                                  ariaLabel="hourglass-loading"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                  colors={["#2268a0", "#72a1ed"]}
                                />
                              </Stack>
                            ) : agentCount.length > 0 ? (
                              agentCount.map((rowData, rowIndex) => {
                                return (
                                  <StyledTableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={rowIndex.id}
                                  >
                                    <StyledTableCell2>
                                      {rowData.total}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.totalpendingcall}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.totalcompletecall}
                                    </StyledTableCell2>
                                  </StyledTableRow>
                                );
                              })
                            ) : (
                              // Data unavailable start
                              <Stack
                                sx={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "calc(100vh - 14rem)",
                                }}
                                justifyContent="center"
                                alignContent="center"
                              >
                                <Stack
                                  className="text-muted"
                                  direction="column"
                                  justifyContent="center"
                                  alignContent="center"
                                >
                                  <span className="mx-auto">
                                    <img
                                      src={Nodata}
                                      alt="pic"
                                      style={{
                                        width: "11rem",
                                        userSelect: "none",
                                      }}
                                    />
                                  </span>
                                  <span className="mx-auto">
                                    <h6
                                      className="text-muted mt-3"
                                      style={{ fontSize: "13px" }}
                                    >
                                      Data unavailable
                                    </h6>
                                  </span>
                                </Stack>
                              </Stack>
                              // Data unavailable end
                            )}
                          </>
                        </StyledTable>
                      </StyledTableContainer>
                    </Box>
                  </div>
                  {/* card-footer */}
                  <div className="card-footer border-0">
                    <Box>
                      <Stack
                        sx={{ width: "100%", height: "100%" }}
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        {/* Pagination content  */}
                        <Typography variant="caption" sx={{ fontSize: "12px" }}>
                          Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                          {Math.min(page * 10, pagination)} of {pagination}{" "}
                          entries
                        </Typography>
                        {/* Pagination  */}
                        <Pagination
                          count={Math.ceil(pagination / 10)}
                          page={page}
                          shape="rounded"
                          color="primary"
                          size="small"
                          style={{ float: "right" }}
                          onChange={handleChange}
                        />
                      </Stack>
                    </Box>
                  </div>
                  {/* card-footer  end*/}
                </>
              );
            case "table4":
              return (
                <>
                  {/* card-body */}
                  <div
                    className="card-body p-1 vh-71 box-inset"
                    sx={{
                      justifyContent: "center",
                      display: "flex",
                      height: "calc(100% - 40px)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10",
                    }}
                  >
                    <Box>
                      <StyledTableContainer sx={{ height: "26rem !important" }}>
                        <StyledTable
                          stickyHeader
                          aria-label="sticky table"
                          size="small"
                        >
                          <>
                            <StyledTableHead>
                              <StyledTableRow>
                                {[
                                  "Agent Name",
                                  "Total Assign Call",
                                  "Total Pending Call",
                                  "Total Complete Call",
                                ].map((headers) => (
                                  <StyledTableCell
                                    style={{ minWidth: "150px" }}
                                  >
                                    {headers}
                                  </StyledTableCell>
                                ))}
                              </StyledTableRow>
                            </StyledTableHead>
                            {loadingAgentService ? (
                              <Stack
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                }}
                              >
                                <Hourglass
                                  visible={true}
                                  height="30"
                                  width="30"
                                  ariaLabel="hourglass-loading"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                  colors={["#2268a0", "#72a1ed"]}
                                />
                              </Stack>
                            ) : smsReport.length > 0 ? (
                              smsReport.map((rowData, rowIndex) => {
                                return (
                                  <StyledTableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={rowIndex.id}
                                  >
                                    <StyledTableCell2>
                                      {rowData.users.username == null ||
                                      rowData.users.username == undefined ||
                                      rowData.users.username == ""
                                        ? "--"
                                        : rowData.users.username}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.total}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.totalpendingcall}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.totalcompletecall}
                                    </StyledTableCell2>
                                  </StyledTableRow>
                                );
                              })
                            ) : (
                              // Data unavailable start
                              <Stack
                                sx={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "calc(100vh - 14rem)",
                                }}
                                justifyContent="center"
                                alignContent="center"
                              >
                                <Stack
                                  className="text-muted"
                                  direction="column"
                                  justifyContent="center"
                                  alignContent="center"
                                >
                                  <span className="mx-auto">
                                    <img
                                      src={Nodata}
                                      alt="pic"
                                      style={{
                                        width: "11rem",
                                        userSelect: "none",
                                      }}
                                    />
                                  </span>
                                  <span className="mx-auto">
                                    <h6
                                      className="text-muted mt-3"
                                      style={{ fontSize: "13px" }}
                                    >
                                      Data unavailable
                                    </h6>
                                  </span>
                                </Stack>
                              </Stack>
                              // Data unavailable end
                            )}
                          </>
                        </StyledTable>
                      </StyledTableContainer>
                    </Box>
                  </div>
                  {/* card-footer */}
                  <div className="card-footer border-0">
                    <Box>
                      <Stack
                        sx={{ width: "100%", height: "100%" }}
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        {/* Pagination content  */}
                        <Typography variant="caption" sx={{ fontSize: "12px" }}>
                          Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                          {Math.min(page * 10, pagination)} of {pagination}{" "}
                          entries
                        </Typography>
                        {/* Pagination  */}
                        <Pagination
                          count={Math.ceil(pagination / 10)}
                          page={page}
                          shape="rounded"
                          color="primary"
                          size="small"
                          style={{ float: "right" }}
                          onChange={handleChange}
                        />
                      </Stack>
                    </Box>
                  </div>
                  {/* card-footer  end*/}
                </>
              );
            default:
              return (
                <>
                  {/* card-body */}
                  <div
                    className="card-body p-1 vh-71 box-inset"
                    sx={{
                      justifyContent: "center",
                      display: "flex",
                      height: "calc(100% - 40px)",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10",
                    }}
                  >
                    <Box>
                      <StyledTableContainer sx={{ height: "26rem !important" }}>
                        <StyledTable
                          stickyHeader
                          aria-label="sticky table"
                          size="small"
                        >
                          <>
                            <StyledTableHead>
                              <StyledTableRow>
                                {[
                                  "Action",
                                  "Brand",
                                  "Customer Name",
                                  "Customer Number",
                                  "Registration No",
                                  "Model Description",
                                  "Chassis No",
                                  "Job Card",
                                  "Invoice Date",
                                  "External Color",
                                  "Location",
                                  "Service Advisor",
                                  "Nature Of Work",
                                  "Job Type",
                                  "Call Status",
                                  "Count",
                                  "Date",
                                  "Timestamp",
                                  "Action",
                                ].map((headers) => (
                                  <StyledTableCell
                                    style={{ minWidth: "150px" }}
                                  >
                                    {headers}
                                  </StyledTableCell>
                                ))}
                              </StyledTableRow>
                            </StyledTableHead>
                            {loadingAgentService ? (
                              <Stack
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                }}
                              >
                                <Hourglass
                                  visible={true}
                                  height="30"
                                  width="30"
                                  ariaLabel="hourglass-loading"
                                  wrapperStyle={{}}
                                  wrapperClass=""
                                  colors={["#2268a0", "#72a1ed"]}
                                />
                              </Stack>
                            ) : serviceReportList.length > 0 ? (
                              serviceReportList.map((rowData, rowIndex) => {
                                return (
                                  <StyledTableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={rowIndex.id}
                                  >
                                    <StyledTableCell2>
                                      <img
                                        className="icons-size"
                                        src={voice}
                                        alt="webchat"
                                        onClick={() => {
                                          makeCall(
                                            rowData.MOBILE,
                                            "service",
                                            rowData.id,
                                            rowData.REG_NO
                                          );
                                        }}
                                      />
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Brand}
                                    </StyledTableCell2>

                                    <StyledTableCell2>
                                      {rowData.CUST_NAME}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.MOBILE}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.REG_NO}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Model_Description}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.CHASSIS_NO}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Job_Card}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Invoice_Date}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.External_Color}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.Location}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.ADVISOR}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.nature_of_work
                                        ? rowData.nature_of_work
                                        : ""}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.job_type ? rowData.job_type : ""}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.callstatus}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {rowData.count}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {moment(rowData.createdAt).format("L")}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      {moment(rowData.createdAt).format(
                                        "hh:mm A"
                                      )}
                                    </StyledTableCell2>
                                    <StyledTableCell2>
                                      <IconButton
                                        onClick={() => {
                                          takeSurvey(rowData, "service");
                                        }}
                                      >
                                        <Swap
                                          size={22}
                                          weight="bold"
                                          style={{ zIndex: 0 }}
                                        />
                                      </IconButton>
                                    </StyledTableCell2>
                                  </StyledTableRow>
                                );
                              })
                            ) : (
                              // Data unavailable start
                              <Stack
                                sx={{
                                  position: "absolute",
                                  width: "100%",
                                  height: "calc(100vh - 14rem)",
                                }}
                                justifyContent="center"
                                alignContent="center"
                              >
                                <Stack
                                  className="text-muted"
                                  direction="column"
                                  justifyContent="center"
                                  alignContent="center"
                                >
                                  <span className="mx-auto">
                                    <img
                                      src={Nodata}
                                      alt="pic"
                                      style={{
                                        width: "11rem",
                                        userSelect: "none",
                                      }}
                                    />
                                  </span>
                                  <span className="mx-auto">
                                    <h6
                                      className="text-muted mt-3"
                                      style={{ fontSize: "13px" }}
                                    >
                                      Data unavailable
                                    </h6>
                                  </span>
                                </Stack>
                              </Stack>
                              // Data unavailable end
                            )}
                          </>
                        </StyledTable>
                      </StyledTableContainer>
                    </Box>
                  </div>
                  {/* card-footer */}
                  <div className="card-footer border-0">
                    <Box>
                      <Stack
                        sx={{ width: "100%", height: "100%" }}
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        {/* Pagination content  */}
                        <Typography variant="caption" sx={{ fontSize: "12px" }}>
                          Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                          {Math.min(page * 10, pagination)} of {pagination}{" "}
                          entries
                        </Typography>
                        {/* Pagination  */}
                        <Pagination
                          count={Math.ceil(pagination / 10)}
                          page={page}
                          shape="rounded"
                          color="primary"
                          size="small"
                          style={{ float: "right" }}
                          onChange={handleChange}
                        />
                      </Stack>
                    </Box>
                  </div>
                  {/* card-footer  end*/}
                </>
              );
          }
        })()}
      </div>
      <Box>
        {/* Filters  */}
        <Drawer
          anchor="right"
          open={showSupervisorfilter}
          onClose={() => {
            setShowSupervisorfilter(false);
          }}
        >
          <Box style={{ width: "20rem" }}>
            {/* Drawer head start */}
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              className="p-3 shadowDrawer"
            >
              <Typography variant="h3" gutterBottom className="drawer-title">
                Filters
              </Typography>
            </Stack>
            {/* Drawer head end */}
            {/* Drawer Content start */}
            <Stack
              className="p-3"
              style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
            >
              <form>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="fromdate" className="form-label">
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={todate}
                    onChange={(e) => setTodate(e.target.value)}
                    max={defaultValue}
                  />
                  {!isToDateValid() && (
                    <span className="text-danger fw-bold fs-10 mt-2">
                      To Date cannot be less than From Date*
                    </span>
                  )}
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="mobilenumber" className="form-label">
                    Enter Brand
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setBrand(e.target.value)}
                  >
                    <option value="">Select Brand</option>
                    <option value="Mazda">Mazda</option>
                    <option value="Mahindra">Mahindra</option>
                    <option value="Preowned">Preowned</option>
                    <option value="Ziebart">Ziebart</option>
                    <option value="Powersport">Powersport</option>
                    <option value="CarBody Worx">CarBody Worx</option>
                    <option value="Rent A Car">Rent A Car</option>
                  </select>
                </div>
              </form>
            </Stack>
            {/* Drawer Content end */}
            {/* Drawer footer start */}
            <Stack
              className="p-2"
              sx={{
                position: "absolute",
                bottom: "0",
                background: "#f9f9f9",
                width: "100%",
                boxShadow:
                  "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
              }}
              direction="row"
              justifyContent="space-between"
              alignContent="center"
            >
              <Button
                variant="contained"
                className="me-2 w-100"
                sx={{
                  textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                  textTransform: "Capitalize",
                }}
                color="error"
                disableElevation
                onClick={() => {
                  setShowSupervisorfilter(false);
                }}
              >
                Close
              </Button>
              <Button
                className="w-100"
                variant="contained"
                disableElevation
                sx={{
                  textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                  textTransform: "Capitalize",
                }}
                id="session_filter_Submit"
                onClick={fetchData}
              >
                Submit
              </Button>
            </Stack>
            {/* Drawer footer end */}
          </Box>
        </Drawer>
      </Box>
    </StyledPaper>
    // Agent contact end here
  );
};

export default connect(mapStateToProps, { setDialedNumberInc })(AgentContact);
